/***
 *
 *   CSV
 *   Convert rows to a CSV string and trigger a browser download
 *
 **********/

// RFC 4180: quote a field only when it contains a comma, quote, or newline; a literal quote doubles.
// CSV/formula injection: a string cell starting with =, +, -, @, tab, or CR
// is evaluated as a formula by Excel/LibreOffice when opened — these exports
// carry customer- and rep-typed text (account/user names, free-text notes),
// so an untouched cell can execute on a support laptop. Prefixing with a
// single quote neutralises it while staying human-readable. Real numbers
// (never attacker-typed free text) are left untouched.
const FORMULA_PREFIX_RE = /^[=+\-@\t\r]/;

function csvField(value) {
  if (value === null || value === undefined) return '';
  let s = String(value);
  if (typeof value === 'string' && FORMULA_PREFIX_RE.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function rowsToCsv(rows, columns) {
  const header = columns.map((c) => csvField(c.label)).join(',');
  const lines = rows.map((row) => columns.map((c) => csvField(row[c.key])).join(','));
  return [header, ...lines].join('\r\n');
}

export function downloadCsv(filename, csvString) {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
